/**
 * @generated SignedSource<<5a2140c3888dc7946d5cd9d96bd2b0e3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BannerSwitch_banner$data = {
  readonly __typename: string;
  readonly company?: {
    readonly id: string;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"InvitedToCompanyTeam_referral" | "NonReferralAcceptanceArtist_referral" | "NonReferralAcceptancePartner_referral" | "ReferralAcceptance_referral">;
  readonly " $fragmentType": "BannerSwitch_banner";
};
export type BannerSwitch_banner$key = {
  readonly " $data"?: BannerSwitch_banner$data;
  readonly " $fragmentSpreads": FragmentRefs<"BannerSwitch_banner">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BannerSwitch_banner",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CompanyNode",
          "kind": "LinkedField",
          "name": "company",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "IndifyToPartnerReferralNode",
      "abstractKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InvitedToCompanyTeam_referral"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NonReferralAcceptanceArtist_referral"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NonReferralAcceptancePartner_referral"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ReferralAcceptance_referral"
    }
  ],
  "type": "ReferralInterface",
  "abstractKey": "__isReferralInterface"
};

(node as any).hash = "c70ff4c99dcbdb2bc4e65786aa4c3567";

export default node;
